// Remembers where the History window was and how big it was when it was last
// closed, across reloads and sessions. Best-effort; storage may be unavailable
// (private mode, quota).

export const WINDOW_GEOMETRY_KEY = 'ai_studio_history_window_geometry'

const GEOMETRY_KEYS = ['x', 'y', 'width', 'height']

const isValidGeometry = geometry => (
  !!geometry
  && GEOMETRY_KEYS.every(key => Number.isFinite(geometry[key]))
  && geometry.width > 0
  && geometry.height > 0
)

export const saveWindowGeometry = ({ x, y, width, height }) => {
  try {
    window.localStorage.setItem(WINDOW_GEOMETRY_KEY, JSON.stringify({ x, y, width, height }))
  } catch (_) {
    // No-op.
  }
}

/**
 * @returns {{ x: number, y: number, width: number, height: number } | null} - The last
 * saved geometry, or null when nothing usable is stored
 */
export const readStoredWindowGeometry = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(WINDOW_GEOMETRY_KEY))
    if (!isValidGeometry(stored)) {
      return null
    }
    const { x, y, width, height } = stored
    return { x, y, width, height }
  } catch (_) {
    return null
  }
}
